import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResetMyPasswordComponent } from './reset-my-password/reset-my-password.component';
import { PasswordRouter } from './reset.routing';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LoginModule } from '../login/login.module';

@NgModule({
  declarations: [ResetMyPasswordComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    FlexLayoutModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    RouterModule.forChild(PasswordRouter),
    LoginModule
  ]
})
export class ResetMyPasswordModule {}
